import { render, staticRenderFns } from "./NewLandingEdit.vue?vue&type=template&id=66598154&scoped=true"
import script from "./NewLandingEdit.vue?vue&type=script&lang=js"
export * from "./NewLandingEdit.vue?vue&type=script&lang=js"
import style0 from "./NewLandingEdit.vue?vue&type=style&index=0&id=66598154&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66598154",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66598154')) {
      api.createRecord('66598154', component.options)
    } else {
      api.reload('66598154', component.options)
    }
    module.hot.accept("./NewLandingEdit.vue?vue&type=template&id=66598154&scoped=true", function () {
      api.rerender('66598154', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/NewLanding/NewLandingEdit.vue"
export default component.exports